import { render, staticRenderFns } from "./selectIngredients.vue?vue&type=template&id=17f33a9e"
import script from "./selectIngredients.vue?vue&type=script&lang=js"
export * from "./selectIngredients.vue?vue&type=script&lang=js"
import style0 from "./selectIngredients.vue?vue&type=style&index=0&id=17f33a9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports